// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"73122b06","41":"88bb3c6c","160":"38de3bb6","208":"e089c8dc","293":"e0f90b34","432":"233edfcf","453":"4433e7fd","516":"f83616e4","519":"4f09e6c9","917":"4fd9b8c1","946":"02abfac7"}[chunkId] + ".chunk.js";
};